export const SCROLL_ANIMATION_TIME = 800;
export const AUTOFOCUS_TIME = Number(process.env.VUE_APP_AUTOFOCUS_TIME || 1000);
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';

export const NEW_MORTGAGE_SLUG = 'new_mortgage';
export const BUY_MORTGAGE_SLUG = 'buy_mortgage';
export const ADVISER_SLUG = 'adviser_chat';
export const HOME_EQUITY_LOAN_SLUG = 'home_equity_loan';
export const DEBT_CONSOLIDATION_PRODUCT_MOTIVE = 'debt_consolidation';
export const WORK_CAPITAL_PRODUCT_MOTIVE = 'work_capital';
export const HOUSE_REMODELING_PRODUCT_MOTIVE = 'house_remodeling';
